// @flow

import {
  URL_APP_LOGIN,
  URL_BECOME_A_WALKER,
  URL_DOG_WALKING_LANDING_PAGE,
  URL_DOG_BOARDING_LANDING_PAGE,
  URL_DOG_DAYCARE_LANDING_PAGE,
  URL_DOG_DROPINS_LANDING_PAGE,
  URL_DOG_SITTING_LANDING_PAGE,
  URL_WAG_TAG_LANDING_PAGE,
  URL_HELP_CENTER,
} from '../../constants/routes.constants';
import { ACTIVE } from '../../constants';

export default [
  {
    id: 0,
    path: URL_BECOME_A_WALKER,
    label: 'Become a Walker',
    subRoutes: [],
    status: ACTIVE,
  },
  {
    id: 1,
    path: '#',
    label: 'Services',
    subRoutes: [
      {
        id: 11,
        path: URL_DOG_WALKING_LANDING_PAGE,
        label: 'Wag! Walk',
        status: ACTIVE,
      },
      {
        id: 12,
        path: URL_DOG_SITTING_LANDING_PAGE,
        label: 'Sitting',
        status: ACTIVE,
      },
      {
        id: 13,
        path: URL_DOG_BOARDING_LANDING_PAGE,
        label: 'Boarding',
        status: ACTIVE,
      },
      {
        id: 14,
        path: URL_DOG_DAYCARE_LANDING_PAGE,
        label: 'Daycare',
        status: ACTIVE,
      },
      {
        id: 15,
        path: URL_DOG_DROPINS_LANDING_PAGE,
        label: 'Drop-in',
        status: ACTIVE,
      },
      {
        id: 2,
        path: URL_WAG_TAG_LANDING_PAGE,
        label: 'Wag! Tag',
        subRoutes: [],
        status: ACTIVE,
      },
    ],
    status: ACTIVE,
  },
  {
    id: 3,
    path: URL_HELP_CENTER,
    label: 'Help Center',
    subRoutes: [],
    status: ACTIVE,
  },
  {
    id: 4,
    path: URL_APP_LOGIN,
    label: 'Login',
    subRoutes: [],
    status: ACTIVE,
  },
];
